import { GRAPH_INSETS } from './consts';
import { getRectCenter, intersect } from '../rectUtil';
import { GraphComponent, INode, Rect as YRect } from '@ardoq/yfiles';
import { Rect } from '../../Rect';

export const zoomToNodeFromCurrentContentRect = (
  node: INode,
  graphComponent: GraphComponent
) => {
  const { viewport, contentBounds } = graphComponent;
  const zoomRectWidth = Math.max(
    viewport.width,
    node.layout.width + GRAPH_INSETS
  );
  const zoomRectHeight = Math.max(
    viewport.height,
    node.layout.height + GRAPH_INSETS
  );
  const [zoomCenterX, zoomCenterY] = getRectCenter(
    Rect.fromRectLike(node.layout)
  );
  const zoomRect = intersect(
    new Rect(
      zoomCenterX - zoomRectWidth / 2,
      zoomCenterY - zoomRectHeight / 2,
      zoomRectWidth,
      zoomRectHeight
    ),
    Rect.fromRectLike(contentBounds)
  );
  graphComponent.zoomToAnimated(
    new YRect(zoomRect.left, zoomRect.top, zoomRect.width, zoomRect.height)
  );
};
